// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { HOME_MODULE, HOME_URL } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { HomeIndex } = lazily(() => import('pages/webpage/home'))

const homeRoutes: IRoute[] = [
  {
    path: HOME_URL.INDEX,
    component: HomeIndex,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: HOME_MODULE,
      requireAuth: false,
      attrs: { label: 'home.home' },
    },
  },
]

export { homeRoutes }
